import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Activitylist from '@/components/Activitylist.vue'
import Order from '@/components/Order.vue'
import confirm from '@/components/confirm.vue'
import bar from '@/components/bar.vue'
import vehicle from '@/components/vehicle.vue'
import change from '@/components/change.vue'
import password from '@/components/password.vue'
import forgetPassword from '@/components/forgetPassword.vue'
import list from '@/components/list.vue'
import meorder from '@/components/meorder.vue'
import introduce from '@/components/introduce.vue'
import signin from '../views/Signin.vue'
import { getAccessId } from '../util/auth'
import orderDetail from '@/components/orderDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/',
    redirect: '/signin'
  },
  {
    path: '',
    redirect: '/signin'
  },
  {
    path: '/signin',
    name: 'signin',
    component: signin,
    beforeEnter: (to, from, next) => {
      if (getAccessId()) {
        next({
          path: '/list',
          query: {redirect: to.fullPath}
        })
      } else {
        next()
      }
    }
  },
  {
	  path: '/bar',
	  name: 'bar',
    component: bar,
    meta: { requiresAuth: true }
  },
  {
	 path: '/Activitylist',
	 name: 'Activitylist',
   component: Activitylist,
   meta: { requiresAuth: true }
  },
  {
  	 path: '/Order',
  	 name: 'Order',
     component: Order,
     meta: { requiresAuth: true }
  },
  {
	path: '/confirm',
	name: 'confirm',
  component: confirm,
  meta: { requiresAuth: true }  
  },
  {
  	path: '/vehicle',
  	name: 'vehicle',
    component: vehicle,
    meta: { requiresAuth: true } 
  },
  {
  	path: '/orderDetail',
  	name: 'orderDetail',
    component: orderDetail,
    meta: { requiresAuth: true } 
  },
  {
	 path: '/change',
	 name: 'change',
   component: change,
   meta: { requiresAuth: true }  
  },
  {
  	 path: '/password',
  	 name: 'password',
     component: password,
     meta: { requiresAuth: true }
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: forgetPassword
 },
  {
	 path: '/list',
	 name: 'list',
   component: list,
   meta: { requiresAuth: true }  
  },
  {
  	 path: '/meorder',
  	 name: 'meorder',
     component: meorder,
     meta: { requiresAuth: true }
  },
  {
  	 path: '/introduce',
  	 name: 'introduce',
     component: introduce,
     meta: { requiresAuth: true } 
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
